/* eslint-disable no-undef */
import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_AGENT_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_AGENT_SUPABASE_ANON_KEY;

export const agentSupabase = createClient(supabaseUrl, supabaseKey);
